import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axiosClient from "../../libs/axiosClient";
import styles from "./EventReview.module.scss";
import HeaderMobile from "../../components/HeaderMobile/HeaderMobile";
import HeaderMain from "../../components/HeaderMain/HeaderMain";

interface Review {
  id: number;
  username: string;
  rating: number;
  gender: string;
  ageGroup: string;
  tags: string[];
  content: string;
  images: string[];
}

const EventReview: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [selectedTab, setSelectedTab] = useState("eventReview");
  const [reviews, setReviews] = useState<Review[]>([]);
  const { hospital_id, product_id } = useParams<{ hospital_id: string; product_id: string }>();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axiosClient.get(
          `/api/v1/review/${hospital_id}/${product_id}`
        );
        console.log("API Response:", response.data);

        const fetchedReviews: Review[] = response.data.map((review: any) => ({
          id: review.id,
          username: review.username,
          rating: review.rating,
          gender: review.gender,
          ageGroup: review.age_group,
          tags: review.tags || [],
          content: review.content,
          images: review.images || [],
        }));
        setReviews(fetchedReviews);
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };

    if (hospital_id && product_id) {
      fetchReviews();
    }
  }, [hospital_id, product_id]);

  return (
    <div className={styles.eventReviewPage}>
      {isMobile ? (
        <HeaderMobile />
      ) : (
        <HeaderMain selectedTab={selectedTab} onTabChange={setSelectedTab} />
      )}
      <main className={styles.mainContent}>
        <div className={styles.reviewSummary}>
          <div className={styles.rating}>
            <span className={styles.score}>4.7</span>
            <span className={styles.label}>후기평점</span>
          </div>
          <div className={styles.statistics}>
            <p>보톡스 162</p>
            <p>여성 125</p>
            <p>50대 이상 30</p>
          </div>
        </div>

        <button className={styles.writeReviewButton}>후기 작성하기</button>

        <div className={styles.reviewTabs}>
          <span className={styles.activeTab}>전체보기 210</span>
          <span>보톡스 162</span>
          <span>가슴성형 20</span>
          <span>필터</span>
        </div>

        <div className={styles.reviewList}>
          {reviews.map((review) => (
            <div key={review.id} className={styles.reviewCard}>
              <div className={styles.header}>
                <span className={styles.username}>
                  {review.username} <span>★({review.rating})</span>
                </span>
                <span>
                  {review.gender} / {review.ageGroup}
                </span>
              </div>
              <div className={styles.content}>{review.content}</div>
              {review.images.length > 0 && (
                <div className={styles.images}>
                  {review.images.map((src, index) => (
                    <img key={index} src={src} alt={`Review ${index}`} />
                  ))}
                </div>
              )}
              {review.tags.length > 0 && (
                <div className={styles.tags}>
                  {review.tags.map((tag, index) => (
                    <span key={index} className={styles.tag}>
                      {tag}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default EventReview;
